import React from 'react';

import { RequiredLabel } from './styles';

export const RequiredField: React.FC<{
  required?: boolean;
  children: React.ReactNode;
}> = ({ required, children }) => {
  return (
    <div>
      {children}
      {required && <RequiredLabel required={required}>*</RequiredLabel>}
    </div>
  );
};
